import React from 'react';
import {getPublicImagePath} from "@nutastic/nutastic-react-app";

const AppLoading = () => {
    return <div className="loading-page">
        <span>Loading...</span>
        <img src={ getPublicImagePath('black-logo.png')} alt="Especially For You | Black Logo - Transparent" />
    </div>;
};

export default AppLoading;
